import React, { Component, Fragment } from "react";
import { Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import store from "../store";
import Main from "./main/Main";
import PrivateRoute from "../components/common/PrivateRoute";
import FedGrantContractSalaryMain from "./main/forms/federal-grant-contract-salary/FedGrantContractSalaryMain";
import TimeAndEffortCertification from "./main/forms/federal-grant-contract-salary/TimeAndEffortCertification";
import AdminLogin from "./admin/auth/AdminLogin";
import AdminDashboard from "./admin/dashboard/AdminDashboard";
import Navigation from "./admin/nav/Navigation";
import TrackForm from "./main/forms/federal-grant-contract-salary/TrackForm";
import "./App.css";
// import RegisterUser from "./admin/auth/RegisterUser";

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Switch>
          <Route exact path="/" component={Main} />
          <Route
            path="/federal-grant-contract-salary"
            component={FedGrantContractSalaryMain}
          />
          <Route
            path="/time-effort-certification-form"
            component={TimeAndEffortCertification}
          />
          <Route path="/track-form" component={TrackForm} />
          <Route path="/admin" component={AdminLogin} />
          {/* <Route path="/register-user" component={RegisterUser} /> */}
          <Fragment>
            <Navigation />
            <PrivateRoute path="/admin-dashboard" component={AdminDashboard} />
          </Fragment>
        </Switch>
      </Provider>
    );
  }
}

export default App;
